// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".datepicker-config-letter .react-datepicker__input-container input {\n  padding: 8px 0;\n}", "",{"version":3,"sources":["webpack://./src/app/pages/configuration/optional-text/RowFilter.scss"],"names":[],"mappings":"AACE;EACE,cAAA;AAAJ","sourcesContent":[".datepicker-config-letter {\n  .react-datepicker__input-container input {\n    padding: 8px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
